export default __webpack_public_path__ + "static/media/edit_document_green.b9241884.svg";